import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrikethrough = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12H17",
			stroke: "black",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.35948 14.4126H8C8.122 16.8514 9.23747 18 12.0087 18C14.7102 18 16 16.8199 16 14.9791C16 14.2618 15.8445 13.7019 15.5466 13.2564H13.4206C14.1406 13.5815 14.5534 14.0712 14.5534 14.9791C14.5534 16.3637 13.6993 16.9615 12.0087 16.9615C10.1961 16.9615 9.49891 16.2378 9.35948 14.4126Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9913 6C9.41177 6 8.17429 7.18006 8.17429 9.05241C8.17429 9.76599 8.32831 10.3131 8.60388 10.7417H10.6966C10.0182 10.4367 9.60349 9.96773 9.60349 9.05241C9.60349 7.79369 10.4575 7.19579 11.9913 7.19579C13.6819 7.19579 14.3965 7.82515 14.5359 9.71325H15.9129C15.7734 7.36887 14.9194 6 11.9913 6Z",
			fill: "black"
		})
	]
});
export default SvgStrikethrough;
